// eslint-disable-next-line
import util from 'util';

import React, { Component } from 'react';
import { connect } from 'react-redux';
// import PropTypes from 'prop-types';

// eslint-disable-next-line
import * as MuiCore from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import * as coreSelectors from './selectors';
import * as coreActions from './actions';

const styles = theme => ({
  root : {
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <MuiCore.Slide direction="up" ref={ref} {...props} />;
});


/*
 * Check if they which to save their login 
 */

class SaveIdentity extends Component {
  render() {
    const { checkSaveIdentity,
            saveIdentity,
            noSaveIdentitySession,
            noSaveIdentityEver} = this.props;

    return (
      <React.Fragment>
        <MuiCore.Dialog open={Boolean(checkSaveIdentity)}
                        maxWidth="sm"
                        TransitionComponent={Transition}>
          <MuiCore.DialogTitle>Stay Logged In?</MuiCore.DialogTitle>
          <MuiCore.DialogContent>
            Do you wish to save your password to this device to
            automatically log in?  This should only be done on
            devices you trust and use regularly. 
          </MuiCore.DialogContent>
          <MuiCore.DialogActions>
            <MuiCore.Button onClick={saveIdentity}>Save Password</MuiCore.Button>
            <MuiCore.Button onClick={noSaveIdentitySession}
                            >Not This Time</MuiCore.Button>
            <MuiCore.Button onClick={noSaveIdentityEver}
                            >Never For This Device</MuiCore.Button>
          </MuiCore.DialogActions>
        </MuiCore.Dialog>
      </React.Fragment>
    );
  }
}

SaveIdentity.propTypes = {
}

SaveIdentity.defaultProps = {
}


const mapStateToProps = (state) => {
  return ({
    checkSaveIdentity : coreSelectors.getCheckSaveIdentity(state),
  });
};

const mapDispatchToProps = {
  saveIdentity: coreActions.saveIdentity,
  noSaveIdentitySession: coreActions.noSaveIdentitySession,
  noSaveIdentityEver: coreActions.noSaveIdentityEver,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(SaveIdentity));

